import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, ButtonToolbar } from 'rsuite';
import { Field } from './common/Field'
import AuthLayout, { authCardClass, focusFirstError } from './common/AuthLayout';
import { toast } from 'react-toastify';
import { Validator } from "@rsuite/validation";

const apiUrl = process.env.REACT_APP_SERVER_API_URL;

const model = Validator.SchemaModel({
  password: "required|min:6|regex:[A-Z]|regex:[a-z]|regex:[0-9]",
}, {
  "password.regex": "Should contain at least one number and have a mixture of uppercase and lowercase letters"
});

const ResetPassword = () => {
    const [formValue, setFormValue] = React.useState({ password: '' });
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const search = useLocation().search;

    const navigate = useNavigate();

    const formRef = React.useRef();

    const resetPassword = () => {
        if (!formRef.current.check()) {
            focusFirstError();
            return;
        }

        setIsSubmitting(true);
        const password = { password: formValue.password };
        axios.post(`${apiUrl}/users/resetPassword?token=${new URLSearchParams(search).get('token')}&id=${new URLSearchParams(search).get('id')}`, password)
            .then(() => {
                toast.success('Your password has been updated successfully.');
                navigate("/");
            })
            .catch(() => {
                setIsSubmitting(false);
                toast.error('We\'re experiencing technical difficulties. Please try again in a few minutes.', { position: "top-center" });
            });
    }


    return (

        <AuthLayout>
            <Form
                ref={formRef}
                onChange={setFormValue}
                formValue={formValue}
                model={model}
                className={authCardClass('compact') + ' auth-form'}
                size="full"
            >

                <h1 className="text-xl font-bold text-gray-900 mb-1">Set a new password</h1>
                <p className="text-sm text-gray-600 mb-4">
                    Choose a new password for your account.
                </p>

                <Field
                    name="password"
                    label="New password"
                    type='password'
                    autoComplete="new-password"
                    autoFocus
                >
                </Field>
                <p className="text-xs text-gray-500 -mt-3 mb-4">
                    At least 6 characters, with uppercase and lowercase letters and a number.
                </p>

                <ButtonToolbar>
                    <Button
                        appearance="primary"
                        onClick={resetPassword}
                        block
                        loading={isSubmitting}
                        disabled={isSubmitting}
                    >
                        Update Password
                    </Button>
                </ButtonToolbar>

            </Form>
        </AuthLayout>
    )
}

export default ResetPassword;
